import { REMOVE_ITEM_MUTATION } from '@/components/MiniCart/miniCart.gql';
import { TENTH_ANNIVERSARY_KEY_CHAINS_SKU } from '@/constants/10th-anniversary-key-chains-sku';
import { useCartContext } from '@/context/cart';
import { useMutation } from '@apollo/client';

export const useResolveCartKeyChains = ({ removeCartItemMutation = REMOVE_ITEM_MUTATION } = {}) => {
  const [{ cartId }] = useCartContext();
  const [reqRemoveItem] = useMutation(removeCartItemMutation);

  const resolveCartKeyChains = ({ cartItems, removeKeyChainsRefetchQueries, afterRemoveKeyChainsFn } = {}) => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) return;

    const hasDress = cartItems.some(
      x =>
        (x?.product?.shipping_type === 'Dresses' || x?.product?.shipping_type === 'Wedding Dresses') &&
        x?.product?.is_try_on !== 1,
    );
    const cartKeyChainsUid = cartItems.find(x => x?.product?.sku === TENTH_ANNIVERSARY_KEY_CHAINS_SKU)?.uid;
    const hasKeyChains = !!cartKeyChainsUid;

    if (!hasDress && hasKeyChains) {
      reqRemoveItem({
        variables: {
          cartId,
          itemId: cartKeyChainsUid,
        },
        refetchQueries: removeKeyChainsRefetchQueries,
        awaitRefetchQueries: true,
      }).then(() => {
        afterRemoveKeyChainsFn?.();
      });
    }
  };

  return { resolveCartKeyChains };
};
